import { createElement } from 'react';

export const DynamicComponent = ({ is, ...rest }) => {
  return createElement(is, { ...rest });
};
